<template>
    <div>
        <!--<div class="item-title">考试信息列表</div>-->
        <div class="list-title">
            <div>序号</div>
            <div>试卷名称</div>
            <div>交卷时间</div>
            <div>分数</div>
            <div></div>
        </div>
        <div v-if="list===null">暂无数据</div>
        <div class="list" v-for="(l,index) in list" :key="l.id">
            <div>{{index+1}}</div>
            <div>{{l.examName}}</div>
            <div>{{l.answerTime}}</div>
            <div>{{l.score}}</div>
            <div>
                <button class="check-btn" @click="openInfo(l)">查看试卷</button>
            </div>
        </div>
        <Pagination :size=total
                    :pageLimit=pageInfo.pageObject.pageSize
                    style="margin:20px 0"
                    v-on:changeCurrent="changeCurrent"></Pagination>
    </div>
</template>

<script>
    import Pagination from '../../components/Pagination'
    export default {
        name: "CompleteExam",
        components:{Pagination},
        data(){
            return{
                list: [],
                pageInfo:{
                    pageObject:{
                        currentPage:1,
                        pageSize: 8
                    },
                    andModel:{
                        examiner:this.$store.getters.getToken.id
                    }
                },
                total:0
            }
        },
        created() {
            this.getAllPaper();
        },
        methods:{
            openInfo(l){
                localStorage.setItem("examScore",l.score);
                window.open("/ViewExam/"+l.id);
            },
            getAllPaper(){
                this.$json("/paperRecord/page","POST",this.pageInfo).then(res=>{
                    this.list=res.data;
                    this.total = res.total;
                })
            },
            changeCurrent(data){
                this.pageInfo.pageObject.currentPage = data;
                this.getAllPaper(this.pageInfo);
            },
        }
    }
</script>

<style scoped lang="less">
    @import '../../assets/css/myCourse.less';
    .list:nth-child(odd), .list-title {
        background-color: #edf5ff;
    }
</style>
